import styled from 'styled-components';
import { Palette } from 'config';

export const PageMainHeader = styled.h1`
  display: flex;
  flex: 0 0 100%;
  max-width: 965px;
  padding: 48px 0;
  margin: 0 auto;
  font-size: 40px;
  color: ${Palette.PrimaryGray._900};
  font-style: normal;
  font-weight: 700;
  line-height: 48px;
  letter-spacing: -0.8px;
`;
